import {
  Alert,
  Heading,
  Link,
  Paragraph,
  Skeleton,
} from "@digdir/designsystemet-react";
import { ExternalLinkIcon } from "@navikt/aksel-icons";
import { Link as RouterLink } from "@tanstack/react-router";
import type { PropsWithChildren } from "react";
import { Trans, useTranslation } from "react-i18next";
import { FormWrapper } from "@/components";
import { AktoerForm } from "../forms";
import { useAktoerData } from "../hooks/";
import { FormPage } from "./FormPage";

export const AktoerPage = () => {
  const { t } = useTranslation();
  const { data: aktoerer, isLoading, error } = useAktoerData();
  return (
    <FormPage>
      <Heading data-size="lg">{t("pages.aktoer.tittel")}</Heading>
      <Paragraph
        data-size="lg"
        className="text-balder-text-subtle whitespace-pre-line"
      >
        <Trans
          i18nKey="pages.aktoer.beskrivelse"
          components={{ Italic: <i /> }}
        />
        <br />
        <Link
          href={t("pages.aktoer.altinnlenke.url")}
          target="_blank"
          rel="noreferrer"
        >
          {t("pages.aktoer.altinnlenke.tittel")}
          <ExternalLinkIcon fontSize={"1.5rem"} className="pl-1" />
        </Link>
      </Paragraph>

      <Paragraph
        data-size="lg"
        className="text-balder-text-subtle whitespace-pre-line"
      >
        <Trans
          i18nKey="pages.aktoer.finner-ikke-selskap"
          components={{
            Link: <LinkToSelskapPage />,
          }}
        />
      </Paragraph>

      {isLoading && (
        <FormWrapper className="flex flex-col">
          <Skeleton variant="text" width={40} className="w-50 h-7" />
          <Skeleton className="w-full h-12" />
          <Skeleton variant="text" width={40} className="w-50 h-7" />
          <Skeleton className="w-full h-12" />
          <span className="flex gap-4">
            <Skeleton variant="circle" className="w-32 h-12" />
            <Skeleton variant="circle" className="w-30 h-12" />
          </span>
        </FormWrapper>
      )}
      {error && (
        <Alert data-color="danger">
          <Heading data-size="xs">{t("skjema.feil-ved-henting")}</Heading>
          <Paragraph>{t("pages.aktoer.feil.hent")}</Paragraph>
        </Alert>
      )}
      {!isLoading && !error && <AktoerForm aktoerer={aktoerer} />}
    </FormPage>
  );
};

const LinkToSelskapPage = ({ children }: PropsWithChildren) => (
  <RouterLink to="/selskap">{children}</RouterLink>
);
